const getDaysInMonth = (month: number, year: number = new Date().getFullYear()) => {
	return new Array(new Date(year, month, 0).getDate()).fill(0).map((_, i) => ({
		title: String(i + 1),
		value: String(i + 1),
	}));
};

export default getDaysInMonth;
